export type Theme = {
  primaryTextColor: string;
  secondaryTextColor: string;
  highlightColor: string;
  highlightDarkerColor: string;
  highlightLighterColor: string;
  bgColor: string;
  borderColor: string;
  logo: string;
  logoWidth: string;
  logoHeight: string;
};

export type Themes = {
  nvidia: Theme;
  base: Theme; // DEPRECATED
  accenture: Theme; // DEPRECATED
  superMicro: Theme; // DEPRECATED
  deloitte: Theme; // DEPRECATED
};

export const themes = {
  nvidia: {
    // colors
    primaryTextColor: "#ffffff",
    secondaryTextColor: "#94a3b8",
    highlightColor: "#76B900",
    highlightDarkerColor: "#59A700",
    highlightLighterColor: "#BBDC80",
    bgColor: "#18181b",
    borderColor: "#1e293b",
    borderPrimary: "#5e5e5e",
    //logo
    logo: "/logos/svg/nvidia-white-text.svg",
    logoWidth: "84px",
    logoHeight: "42px",
  },
  // DEPRECATED - brev legacy theme
  base: {
    // colors
    primaryTextColor: "#ffffff",
    secondaryTextColor: "#94a3b8",
    highlightColor: "#06b6d4",
    highlightDarkerColor: "#0891b2",
    highlightLighterColor: "#22d3ee",
    bgColor: "#18181b",
    borderColor: "#1e293b",
    borderPrimary: "#5e5e5e",
    // logo
    logo: "/logos/svg/nvidia-white-text.svg",
    logoWidth: "84px",
    logoHeight: "42px",
  },
  // DEPRECATED - legacy enterprise theme
  accenture: {
    // colors
    primaryTextColor: "#ffffff",
    secondaryTextColor: "#94a3b8",
    highlightColor: "#A100FF",
    highlightDarkerColor: "#9233ff",
    highlightLighterColor: "#c084fc",
    bgColor: "#18181b",
    borderColor: "#1e293b",
    borderPrimary: "#e5e7eb",
    logo: "/logos/svg/accenture-logo.svg",
    logoWidth: "32px",
    logoHeight: "32px",
  },
  // DEPRECATED - legacy enterprise theme
  deloitte: {
    // colors
    primaryTextColor: "#ffffff",
    secondaryTextColor: "#94a3b8",
    highlightColor: "#86BC25",
    highlightDarkerColor: "#43B02A",
    highlightLighterColor: "#C4D600",
    bgColor: "#18181b",
    borderColor: "#1e293b",
    borderPrimary: "#5e5e5e",
    logo: "/logos/svg/deloitte-logo.svg",
    logoWidth: "70px",
    logoHeight: "70px",
  },
  // DEPRECATED - legacy enterprise theme
  superMicro: {
    // colors
    primaryTextColor: "#ffffff",
    secondaryTextColor: "#94a3b8",
    highlightColor: "#003A70",
    highlightDarkerColor: "#9233ff",
    highlightLighterColor: "#c084fc",
    bgColor: "#18181b",
    borderColor: "#1e293b",
    borderPrimary: "#5e5e5e",
    logo: "/logos/svg/super-micro-logo.svg",
    logoWidth: "60px",
    logoHeight: "32px",
  },
};
